module.exports = __webpack_public_path__ + "static/media/nft.18b62c9f.png";